// ProjectList.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import './ProjectList.css';

// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${url}/api/projects`);
        setProjects(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch projects');
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this project?")) return;

    try {
      await axios.delete(`${url}/api/projects/${id}`);
      setProjects(projects.filter(project => project._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete project');
    }
  };

  if (loading) return <div className="loading">Loading projects...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="projects-container">
      <div className="header">
        <h2>Projects List</h2>
        <button 
          onClick={() => navigate('/AddProject')}
          className="add-button"
        >
          <Plus size={16} /> Add Project
        </button>
      </div>

      <table className="projects-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Contact Person</th>
            <th>Contact Phone</th>
            <th>Location</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {projects.map(project => (
            <tr key={project._id}>
              <td>{project.title}</td>
              <td>{project.description}</td>
              <td>{project.start_date}</td>
              <td>{project.end_date}</td>
              <td>{project.contact_person}</td>
              <td>{project.contact_phone}</td>
              <td>{project.location}</td>
              <td>
                {project.image && (
                  <img 
                    src={`${url}/uploads/${project.image}`} 
                    alt="project" 
                    width="50" 
                  />
                )}
              </td>
              <td className="actions">
                <button 
                  onClick={() => navigate(`/projects/edit/${project._id}`)}
                  
                  className="edit-btn"
                >
                  <Edit size={14} />
                </button>
                {/* <button 
                  onClick={() => handleDelete(project._id)}
                  className="delete-btn"
                >
                  <Trash2 size={14} />
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectList;
